import React, {useEffect, useState} from 'react';

import {Button} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';

import {proceedContinueProfilePause, proceedRefillBufferPause} from '@/businesses/autoProfileBusiness';
import IntlMessage from '@/components/intlMessage/IntlMessage';
import StandalonePopUp from '@/components/popup/StandalonePopUp';
import ToggleButtonCustom from '@/components/togglebutton/src/ToggleButtonCustom';
import useIntlFormat from '@/hooks/useIntlFormat';
import {getShowPauseToRefillModal} from '@/selectors/autoProfileSelector';

const DISPLAY_NAME = 'pause-auto-profile-modal';

function PauseAutoProfileModal() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntlFormat();
  const show = useSelector(getShowPauseToRefillModal);
  const [selectedId, setSelectedId] = useState('');
  const [isProceed, setIsProceed] = useState(false);

  useEffect(() => {
    if (show) {
      setIsProceed(false);
      setSelectedId('');
    }
  }, [show]);

  const toggleButtons = [
    {
      id: `${DISPLAY_NAME}-button-continue-profile`,
      label: formatMessage({id: 'modal.pauseAutoProfile.button.continueProfile'}),
    },
    {
      id: `${DISPLAY_NAME}-button-refill-buffer`,
      label: formatMessage({id: 'modal.pauseAutoProfile.button.refillBuffer'}),
    },
  ];

  const handleOnClickToggleButton = (e) => {
    setSelectedId(e.currentTarget.id);
  };

  const handleOnClickProceed = async () => {
    setIsProceed(true);

    switch (selectedId) {
      case toggleButtons[0].id:
        await dispatch(proceedContinueProfilePause());
        break;
      case toggleButtons[1].id:
        await dispatch(proceedRefillBufferPause());
        break;
      default:
        break;
    }

    setIsProceed(false);
  };

  const renderTitle = () => formatMessage({id: 'modal.pauseAutoProfile.title'});

  const renderBody = () => (
    <div className={`${DISPLAY_NAME}-body`}>
      <IntlMessage id="modal.pauseAutoProfile.message" />
      <ToggleButtonCustom
        buttonProp={toggleButtons}
        value={selectedId}
        onClick={handleOnClickToggleButton}
        block
        vertical
      />
    </div>
  );

  const renderFooter = () => {
    const isDisabled = !selectedId || isProceed;
    return (
      <div className="buttondiv">
        <Button
          className="primaryButton no-outline"
          id={`${DISPLAY_NAME}-primary-button`}
          bsSize="large"
          onClick={handleOnClickProceed}
          disabled={isDisabled}
        >
          {formatMessage({id: 'modal.pauseAutoProfile.primaryButton'})}
        </Button>
      </div>
    );
  };

  return (
    <StandalonePopUp
      isPopUpVisible={show}
      dialogClassName={DISPLAY_NAME}
      contents={{
        popUpTitle: renderTitle(),
        popUpBody: renderBody(),
        popUpFooter: renderFooter(),
      }}
      hideCloseButton
    />
  );
}
export default PauseAutoProfileModal;
